import { cmdUrl } from './apiUrl';
import { FILE_UPLOAD_LIMITS } from './attachment-policy';

export function generateImage(formData) {
  const photos = formData.getAll('photos');
  const promises = photos.map((photo) =>
    createImageTag(photo).then((img) => ({
      id: img,
      originalName: photo.name,
      fileName: photo.name,
      url: img,
    })),
  );
  return Promise.all(promises);
}

export function createImageTag(file) {
  return new Promise((resolve) => {
    const fReader = new FileReader();
    const img = document.createElement('img');

    fReader.onload = () => {
      img.src = fReader.result;
      resolve(createCanvas(img));
    };

    fReader.readAsDataURL(file);
  });
}

export function createCanvas(img) {
  const canvas = document.createElement('canvas');
  canvas.width = img.width;
  canvas.height = img.height;

  const ctx = canvas.getContext('2d');
  ctx.drawImage(img, 0, 0);
  const dataURL = img.src;
  return dataURL;
}

//TODO: bo khi chay dc thanh cong
export function typecheck(oInput) {
  var _validFileExtensions = ['.jpg', '.jpeg', '.bmp', '.gif', '.png'];
  if (oInput.length > 0) {
    var blnValid = false;
    for (var j = 0; j < _validFileExtensions.length; j++) {
      var sCurExtension = _validFileExtensions[j];
      if (
        oInput
          .substr(oInput.length - sCurExtension.length, sCurExtension.length)
          .toLowerCase() == sCurExtension.toLowerCase()
      ) {
        blnValid = true;
        break;
      }
    }
    if (!blnValid) {
      return false;
    }
  }
  return true;
}

export function checkTypeFile(file) {
  const validExtensions = ['.jpg', '.jpeg', '.bmp', '.gif', '.png'];
  if (file.length > 0) {
    for (const extension of validExtensions) {
      const currentExtension = file.substr(
        file.length - extension.length,
        extension.length,
      );
      if (currentExtension.toLowerCase() === extension.toLowerCase()) {
        return true;
      }
    }
  }
  return false;
}

// Validate file size
export function validateFileSize(file, maxSizeInMB = 10) {
  const maxSizeInBytes = maxSizeInMB * 1024 * 1024;
  return file.size <= maxSizeInBytes;
}

// Format file size - chỉ hiển thị theo MB
export function formatFileSizeMB(bytes) {
  if (!bytes) return '0 MB';

  const mbSize = bytes / (1024 * 1024);
  return parseFloat(mbSize.toFixed(2)) + ' MB';
}

// Check if file is image
export function isImageFile(fileType) {
  return [
    'image/jpeg',
    'image/jpg',
    'image/png',
    'image/gif',
    'image/bmp',
  ].includes(fileType);
}

// Check if file is PDF
export function isPdfFile(fileType) {
  return fileType === 'application/pdf';
}

export function ftruncate(n) {
  // var len = 10;
  const ext = n.substring(n.lastIndexOf('.') + 1, n.length).toLowerCase();
  const filename = n.replace('.' + ext, '');
  // if (filename.length <= len) {
  //   return n;
  // }
  // filename = filename.substr(0, len) + (n.length > len ? '[...]' : '');
  return filename + '.' + ext;
}

export const getApiUrlByEntity = (entity) => {
  switch (entity) {
    case 'bills':
      return cmdUrl.FileBills;
    case 'contracts':
      return cmdUrl.FileBills;
    case 'test-drives': // Thêm case cho test drive
      return cmdUrl.FileTestDrives;
    default:
      return cmdUrl.File; // Default fallback
  }
};

/** Đuôi viết thường, không kèm dấu chấm. Rỗng nếu tên tệp không có đuôi. */
export function getFileExtension(fileName) {
  if (!fileName || !fileName.includes('.')) return '';
  return fileName.split('.').pop().toLowerCase();
}

/**
 * Nhóm tệp để quyết định cách xem trước. Phân theo đuôi vì danh sách trả về từ
 * `/files-bill` không kèm mimetype.
 */
export function getFileCategory(fileName) {
  const ext = getFileExtension(fileName);
  if (['jpg', 'jpeg', 'bmp', 'gif', 'png', 'webp'].includes(ext))
    return 'image';
  if (ext === 'pdf') return 'pdf';
  return 'other';
}

/**
 * Trần dung lượng theo đuôi. Phải khớp `getMaxFileSizeByExtension` của backend — lệch
 * thì người dùng qua cửa client rồi mới bị server chặn.
 */
export function getMaxFileSizeByExtension(fileName) {
  const category = getFileCategory(fileName);
  if (category === 'pdf') return FILE_UPLOAD_LIMITS.MAX_FILE_SIZE_PDF;
  if (category === 'image') return FILE_UPLOAD_LIMITS.MAX_FILE_SIZE_IMAGE;
  return FILE_UPLOAD_LIMITS.MAX_FILE_SIZE_DOCUMENT;
}

/** Icon theo loại tệp, dùng khi không có thumbnail ảnh. */
export function getFileTypeIcon(fileName) {
  const ext = getFileExtension(fileName);
  if (ext === 'pdf') return 'fas fa-file-pdf fa-3x text-danger';
  if (['doc', 'docx'].includes(ext))
    return 'fas fa-file-word fa-3x text-primary';
  if (['xls', 'xlsx'].includes(ext))
    return 'fas fa-file-excel fa-3x text-success';
  if (['txt'].includes(ext)) return 'fas fa-file-alt fa-3x text-secondary';
  return 'fas fa-file fa-3x text-secondary';
}

/** Cắt tên dài nhưng giữ đuôi để còn nhận ra loại tệp. */
export function truncateFileName(name, maxLength = 14) {
  if (!name) return '';
  if (name.length <= maxLength) return name;

  const ext = name.includes('.') ? '.' + getFileExtension(name) : '';
  const keep = maxLength - ext.length - 1;

  // Đuôi dài bất thường (hoặc maxLength quá nhỏ) khiến phần giữ lại thành âm.
  if (keep <= 0) return name.substring(0, maxLength) + '…';

  return name.substring(0, keep) + '…' + ext;
}
